var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconJavascript(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_748_1160)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.7581 0.321289C44.572 0.117615 44.3095 0 44.0316 0H2.90662C2.62836 0 2.36588 0.117615 2.17978 0.321289C1.99403 0.528908 1.90367 0.801071 1.93307 1.07718L5.84986 40.2436C5.88894 40.6276 6.14748 40.9525 6.51359 41.0759L24.1386 46.9509C24.2404 46.9824 24.3423 47 24.448 47C24.5657 47 24.6811 46.9785 24.7926 46.9372L40.4594 41.0622C40.808 40.9332 41.0529 40.614 41.088 40.2436L45.0048 1.07718C45.0342 0.801071 44.9439 0.528908 44.7581 0.321289Z",
    fill: "#FFC107"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.448 47C24.3423 47 24.2404 46.9824 24.1386 46.9509L6.51359 41.0759C6.14748 40.9547 5.88894 40.6276 5.84986 40.2436L1.93307 1.07718C1.90367 0.801071 1.99403 0.528908 2.17978 0.321289C2.36588 0.117615 2.62836 0 2.90662 0H44.0316C44.3095 0 44.572 0.117615 44.7581 0.321289C44.9439 0.526756 45.0342 0.801071 45.0048 1.07718L41.088 40.2436C41.0507 40.614 40.8062 40.9332 40.4594 41.0622L24.7926 46.9372C24.6811 46.9785 24.5657 47 24.448 47ZM7.73385 39.4174L24.4287 44.983L39.2001 39.4429L42.9483 1.95821H3.98954L7.73385 39.4174Z",
    fill: "#050C12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.407 36.2292C25.9975 36.2292 25.6156 35.9686 25.4765 35.5594C25.3062 35.0463 25.5844 34.4919 26.0954 34.3198L31.4203 32.5455L33.0673 23.5H26.407C25.8663 23.5 25.4277 23.0614 25.4277 22.5207V10.7707C25.4277 10.2303 25.8663 9.79175 26.407 9.79175H36.1984C36.5 9.79175 36.7861 9.93052 36.9719 10.1675C37.158 10.4046 37.2225 10.714 37.1501 11.0077L36.1712 14.9245C36.0399 15.4491 35.515 15.7625 34.9843 15.6373C34.4575 15.5061 34.1402 14.9733 34.2714 14.4504L34.943 11.75H27.3859V21.5417H34.2402C34.53 21.5417 34.8061 21.669 34.9922 21.8942C35.1783 22.1155 35.2564 22.4109 35.2037 22.6971L33.2452 33.4678C33.1806 33.8203 32.93 34.1082 32.5911 34.2219L26.7161 36.1801C26.6125 36.2135 26.5106 36.2292 26.407 36.2292Z",
    fill: "#050C12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4899 36.2292C22.3999 36.2292 22.3095 36.2174 22.2195 36.1898L15.3656 34.2316C15.0128 34.1319 14.7485 33.8418 14.6743 33.4814L13.695 28.5857C13.5874 28.055 13.932 27.5401 14.4645 27.4343C14.9679 27.3228 15.5083 27.6692 15.6163 28.2038L16.4779 32.5122L21.5106 33.9515V11.75H10.7399C10.1995 11.75 9.76062 11.3114 9.76062 10.7707C9.76062 10.2303 10.1995 9.79175 10.7399 9.79175H22.4899C23.0303 9.79175 23.4692 10.2303 23.4692 10.7707V35.25C23.4692 35.5573 23.3261 35.8474 23.0794 36.0313C22.9069 36.1626 22.6993 36.2292 22.4899 36.2292Z",
    fill: "#050C12"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_748_1160"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 47,
    height: 47,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconJavascript);
export default __webpack_public_path__ + "static/media/icon_javascript.1973b23c88adaaddffc6f9be14d7d9e1.svg";
export { ForwardRef as ReactComponent };